/* Hundben: sätter klassen hb-cart-open på <html> när sidovarukorgen är öppen (2026-10-15) */
(function () {
  function sync(drawer) {
    document.documentElement.classList.toggle('hb-cart-open', !!(drawer && drawer.hasAttribute('open')));
  }
  function init() {
    var drawer = document.querySelector('cart-drawer');
    if (!drawer) return;
    new MutationObserver(function () { sync(drawer); }).observe(drawer, { attributes: true, attributeFilter: ['open'] });
    sync(drawer);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
